import { render, staticRenderFns } from "./SportsAnalytics.vue?vue&type=template&id=7c2f3b72&"
import script from "./SportsAnalytics.vue?vue&type=script&lang=js&"
export * from "./SportsAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports